module.exports = __webpack_public_path__ + "static/media/nina_carducci_mobile.867f2883.webp";